import { graphql } from "../generated/gql";

export const GetCustomSummaryResults = graphql(`
  query GetCustomSummaryResults($input: GetCustomSummaryResultsInput) {
    getCustomSummaryResults(input: $input) {
      ... on GetCustomSummaryResultsResult {
        __typename
        items {
          ...CustomSummaryResult
        }
        pageInfo {
          currentToken
          limit
          nextToken
          previousToken
          total
        }
      }
      ... on GenericException {
        ...BaseException
      }
      ... on InsufficientLicenseException {
        ...InsufficientLicenseException
      }
      ... on UserInputException {
        ...UserInputException
      }
    }
  }
`);
